import { createContext, useState } from "react";
import PropTypes from "prop-types";

import { COUNSELLOR_PORTALS } from "../components/CounsellorPortal/portalConfig";

const getStoredCounsellorUser = (storageKey) => {
  try {
    const storedCounsellorUser = localStorage.getItem(storageKey);
    return storedCounsellorUser ? JSON.parse(storedCounsellorUser) : null;
  } catch {
    localStorage.removeItem(storageKey);
    return null;
  }
};

const CounsellorAuthContext = createContext();

export const CounsellorAuthProvider = ({ children, portal = COUNSELLOR_PORTALS.career }) => {
  const { storageKey } = portal;
  const [counsellorUser, setCounsellorUser] = useState(() =>
    getStoredCounsellorUser(storageKey),
  );

  const loginCounsellor = (token, userInfo, counsellor, dashboard) => {
    const userData = {
      token,
      role: portal.role,
      userInfo,
      counsellor,
      dashboard,
    };

    localStorage.setItem(storageKey, JSON.stringify(userData));
    setCounsellorUser(userData);
  };

  const logoutCounsellor = () => {
    localStorage.removeItem(storageKey);
    setCounsellorUser(null);
  };

  const updateCounsellorProfile = (profile) => {
    if (!profile || typeof profile !== "object") return;

    setCounsellorUser((currentUser) => {
      if (!currentUser) return currentUser;

      const updatedUser = {
        ...currentUser,
        userInfo: {
          ...currentUser.userInfo,
          email: profile.email || currentUser.userInfo?.email,
          name: profile.full_name || profile.name || currentUser.userInfo?.name,
          contact_number:
            profile.phone_number ?? currentUser.userInfo?.contact_number,
        },
        counsellor: {
          ...currentUser.counsellor,
          ...profile,
        },
      };

      localStorage.setItem(
        storageKey,
        JSON.stringify(updatedUser),
      );
      return updatedUser;
    });
  };

  return (
    <CounsellorAuthContext.Provider
      value={{
        portal,
        counsellorUser,
        loginCounsellor,
        logoutCounsellor,
        updateCounsellorProfile,
      }}
    >
      {children}
    </CounsellorAuthContext.Provider>
  );
};

CounsellorAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
  portal: PropTypes.shape({
    storageKey: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
  }),
};

export default CounsellorAuthContext;
